import { NgModule } from '@angular/core';
import { ShareButtonComponent } from './share-button/share-button';
import { IonicModule } from 'ionic-angular';
import { FilterSettingsComponent } from './filter-settings/filter-settings';
import { ResultListStatsComponent } from './result-list-stats/result-list-stats';
import { PercentageListItemContentComponent } from './percentage-list-item-content/percentage-list-item-content';
import { EffectStatsIconComponent } from './effect-stats-icon/effect-stats-icon';
import { UsageWarningsComponent } from './usage-warnings/usage-warnings';

@NgModule({
	declarations: [ShareButtonComponent,
		FilterSettingsComponent,
    ResultListStatsComponent,
    PercentageListItemContentComponent,
    EffectStatsIconComponent,
    UsageWarningsComponent],
	imports: [IonicModule],
	exports: [ShareButtonComponent,
		FilterSettingsComponent,
    ResultListStatsComponent,
    PercentageListItemContentComponent,
    EffectStatsIconComponent,
    UsageWarningsComponent]
})
export class ComponentsModule { }



// WEBPACK FOOTER //
// ./src/components/components.module.ts